import i18next from "i18next";
import { localeKeys } from "../locales";
import type { LocaleType } from "../locales";
import { keys } from "../strings";

/** Keeps `<html lang>` in sync with i18n and discourages browser auto-translate. */
export function syncHtmlLanguageAttributes(language: string): void {
  if (typeof document === "undefined") {
    return;
  }

  const lang = language.startsWith("en") ? "en" : "sv";
  document.documentElement.lang = lang;
  document.documentElement.setAttribute("translate", "no");
}

/**
 * Returns the current language set in i18next.
 * @returns {string} The current language code.
 */
export function getCurrentLanguage(): string {
  return i18next.language;
}

/**
 * Sets the language for i18next.
 * @param {string} language - The language code to set.
 * @returns {Promise<void>} A promise that resolves when the language is set.
 */
export async function setLanguage(language: LocaleType): Promise<void> {
  // Persist selection so it survives reloads and is picked up by the detector
  localStorage.setItem(keys.localStorage.language, language);
  localStorage.setItem(keys.localStorage.i18nextLng, language);
  await i18next.changeLanguage(language);
  syncHtmlLanguageAttributes(language);
  return Promise.resolve();
}

/**
 * Checks if a string is a valid locale key.
 * @param {string} key - The locale key to check.
 * @returns {boolean} True if the key is valid, false otherwise.
 */
export function isValidLocaleKey(key: string): boolean {
  return (localeKeys as Array<string>).includes(key);
}
